import { connect } from "react-redux"

import { selectIsLoggedIn } from "redux/reducers/core/authentication"

import { createLoadLoggedInUserAction as loadUser } from "redux/reducers/entities/users/actions"
import {
    selectIsLoading,
    selectLoadingError,
    selectHasFetchedUser,
} from "redux/reducers/entities/users"

const mapStateToProps = state => ({
    isLoggedIn: selectIsLoggedIn(state),
    isLoadingLoggedInUser: selectIsLoading(state),
    hasFetchedLoggedInUser: selectHasFetchedUser(state),
    loadingLoggedInUserError: selectLoadingError(state),
})

const mapDispatchToProps = {
    loadUser,
}

export default connect(mapStateToProps, mapDispatchToProps)
